<!-- "Áreas › Finca Principal › Parcela A ⌄", todo en el mismo gris (azul al pasar el ratón por lo que se pulsa) -->
<nav class="area-nav" *ngIf="levels.length" aria-label="Áreas">
  <a class="area-nav__link" (click)="goToList()">Áreas</a>

  <ng-container *ngFor="let level of levels; let last = last; trackBy: trackByLevel">
    <span class="area-nav__separator" aria-hidden="true">›</span>
    <a class="area-nav__link" [class.area-nav__link--current]="last" (click)="open(level.node)"
      [attr.aria-current]="last ? 'page' : null">{{ level.node.name }}</a>

    <!-- Áreas de un nivel anterior: su flecha enseña las de ese mismo nivel -->
    <ng-container *ngIf="!last && level.siblings.length > 1">
      <button type="button" class="area-nav__toggle" [matMenuTriggerFor]="siblingsMenu"
        matTooltip="Otras áreas de este nivel" aria-label="Otras áreas de este nivel">
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #siblingsMenu="matMenu">
        <ng-container *ngTemplateOutlet="areaGroups; context: { $implicit: level.siblingGroups, current: level.node }"></ng-container>
      </mat-menu>
    </ng-container>

    <!-- El área de la pantalla: una sola flecha con las de su mismo nivel y sus subáreas -->
    <ng-container *ngIf="last && (level.siblings.length > 1 || children.length)">
      <button type="button" class="area-nav__toggle" [matMenuTriggerFor]="currentMenu"
        matTooltip="Otras áreas y subáreas" aria-label="Otras áreas y subáreas">
        <mat-icon>expand_more</mat-icon>
      </button>
      <!-- Primero las de su mismo nivel y después sus subáreas, cada grupo con el nombre de su tipo ("Parcela") -->
      <mat-menu #currentMenu="matMenu">
        <ng-container *ngIf="level.siblings.length > 1">
          <ng-container *ngTemplateOutlet="areaGroups; context: { $implicit: level.siblingGroups, current: level.node }"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="areaGroups; context: { $implicit: childGroups, current: null }"></ng-container>
      </mat-menu>
    </ng-container>
  </ng-container>
</nav>

<!-- Un apartado por tipo de área: su nombre (el de la plantilla del admin) y sus áreas -->
<ng-template #areaGroups let-groups let-current="current">
  <ng-container *ngFor="let group of groups">
    <div class="area-nav__menu-title">{{ group.title }}</div>
    <ng-container *ngTemplateOutlet="areaItems; context: { $implicit: group.items, current: current }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #areaItems let-items let-current="current">
  <button mat-menu-item *ngFor="let item of items; trackBy: trackByNode" (click)="open(item)"
    [class.area-nav__menu-item--current]="item.areaEntryId === current?.areaEntryId">
    <mat-icon *ngIf="item.areaEntryId === current?.areaEntryId">check</mat-icon>
    <span>{{ item.name }}</span>
  </button>
</ng-template>
